import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const DeleteProjectDialog = ({
  open,
  onClose,
  deletePassword,
  setDeletePassword,
  deleteError,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Project</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Are you sure you want to delete this project? This action cannot be undone.
      </Typography>
      <TextField
        label="Enter password to confirm deletion"
        type="password"
        fullWidth
        value={deletePassword}
        onChange={(e) => setDeletePassword(e.target.value)}
        error={Boolean(deleteError)}
        helperText={deleteError}
        sx={{ mt: 1 }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteProjectDialog;
